var map = {
	"./agua/agua.module": [
		"./src/app/agua/agua.module.ts",
		"default~agua-agua-module~config-modulo-mqtt-config-modulo-mqtt-module~datacenter-datacenter-module",
		"default~agua-agua-module~datacenter-datacenter-module",
		"agua-agua-module"
	],
	"./config-modulo-mqtt/config-modulo-mqtt.module": [
		"./src/app/config-modulo-mqtt/config-modulo-mqtt.module.ts",
		"default~agua-agua-module~config-modulo-mqtt-config-modulo-mqtt-module~datacenter-datacenter-module",
		"config-modulo-mqtt-config-modulo-mqtt-module"
	],
	"./datacenter/datacenter.module": [
		"./src/app/datacenter/datacenter.module.ts",
		"default~agua-agua-module~config-modulo-mqtt-config-modulo-mqtt-module~datacenter-datacenter-module",
		"default~agua-agua-module~datacenter-datacenter-module",
		"datacenter-datacenter-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./principal/principal.module": [
		"./src/app/principal/principal.module.ts",
		"principal-principal-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;